<template>
  <div class="mod-login login-bg" style="height:100%">
    <mini-header :headerTitle="'欢迎登录'"></mini-header>
    <div style="height: calc(100% - 141px);position: relative;min-height: 712px;">
      <el-carousel trigger="click" :height="'100%'" :interval="5000" arrow="never">
        <el-carousel-item v-for="(item, i) in rotationChart" :key="i">
          <img :src="getUrl(item.imageUrl)" style="width: 100%;height: 100%;" @click="goUrl(item)" />
        </el-carousel-item>
      </el-carousel>
      <div class="login-panel" style="position: absolute;right: 15%;top: calc(50% - 264px);z-index: 2;">
        <div class="login-title">
          <h3 v-if="!captchaForm">
            欢迎来到,<br />
            {{ $store.state.pageInfo && $store.state.pageInfo.systemName || '' }}
          </h3>
          <i @click="captchaLogin" style="color: #2962B0;font-size: 24px;cursor: pointer;" class="el-icon-back" v-if="captchaForm"></i>
          <p v-if="captchaForm" class="captchaLoginTitle">验证码登录</p>
          <p v-if="captchaForm" class="captchaLoginTitle1"></p>
        </div>
        <div class="login-form">
          <el-form :model="loginForm" :rules="rules" @keyup.enter.native="submitForm()" ref="loginForm">
            <input type="password" hidden autocomplete="new-password" />
            <el-form-item prop="tel">
              <el-input v-model="loginForm.tel" placeholder="手机号" maxlength="11">
                <i slot="prefix" class="phoneIcon"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" v-if="!captchaForm">
              <el-input :type="!pwdShow ? 'password' : 'text'" v-model="loginForm.password" placeholder="密码" autocomplete="off" maxlength="16">
                <i slot="prefix" class="pwdIcon"></i>
                <i slot="suffix" @click.prevent.stop="showPwdHandle" class="eye" :class="!pwdShow ? 'oeye' : 'ceye'"></i>
              </el-input>
            </el-form-item>
            <el-row :gutter="18" v-if="!captchaForm">
              <el-col :span="15">
                <el-form-item prop="captcha">
                  <el-input placeholder="验证码" v-model="loginForm.captcha" maxlength="4">
                    <i slot="prefix" class="el-input__icon captcha_icon"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9"><img :src="captchaPath" class="captcha_img" alt="" @click="getCaptcha()" style="cursor: pointer" /></el-col>
            </el-row>
            <div v-if="captchaForm" class="captchaForm">
              <el-form-item prop="captcha_phone">
                <el-input v-model="loginForm.captcha_phone" maxlength="6"></el-input>
              </el-form-item>
              <div class="getcaptcha" @click="getCaptchaHandle">
                <span v-show="showCaptcha">获取验证码</span>
                <span v-show="!showCaptcha">{{ count }}s后重新发送</span>
              </div>
            </div>
            <div style="margin-bottom: 27px;">
              <!-- <el-checkbox v-model="checked">记住密码</el-checkbox> -->
              <span style="margin-right: 150px;color: #1460AE;cursor: pointer;" @click="$router.push({ name: 'resetpwd' })">忘记密码?</span>
              <span style="color: #1460AE;cursor: pointer;" @click="$router.push({ name: 'register' })">注册新用户</span>
            </div>
            <el-form-item :style="{'margin-bottom': captchaForm?'127px':'22px'}">
              <el-button type="primary" class="submit_btn" round @click="submitForm()">立即登录</el-button>
            </el-form-item>
            <p v-if="!captchaForm" @click="captchaLogin" style="font-size: 16px;color: #1460AE;text-align: center;margin-bottom: 29px;cursor: pointer;">验证码登录</p>
            <p class="hold">技术支持：</p>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer_box">
      <main-footer></main-footer>
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils/validate";
import { RSAEncrypt,previewUrl } from "@/utils";
import MiniHeader from "./../common/mini-header.vue";
import MainFooter from "./../main-footer.vue";
export default {
  components: {
    MiniHeader,
    MainFooter
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      checked: true,
      loginForm: {
        tel: "",
        password: "",
        captcha: "",
      },
      rules: {
        tel: [
          { required: true, message: "登录账户不能为空！", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        password: [{ required: true, message: "密码不能为空！", trigger: "blur" }],
        captcha: [
          { required: true, message: "验证码不能为空！", trigger: "blur" },
          { min: 4, max: 4, message: "验证码错误", trigger: "blur" },
        ],
        captcha_phone: [{ required: true, message: "验证码不能为空！", trigger: "blur" }]
      },
      captchaPath: "",
      pwdShow: false,
      rotationChart: [],
      captchaForm: false,
      showCaptcha: true,
      timer: null,
      count: ''
    };
  },
  created() {
    this.getCaptcha();
    this.getBanner();
  },
  methods: {
    getUrl(url){
			return previewUrl(url);
		},
    // 获取验证码基于手机号
    getCaptchaHandle() {
      if (!this.showCaptcha) return
      this.$refs["loginForm"].validateField("tel", (valid) => {
        if (!valid) {
          let params = {
            phone: this.loginForm.tel,
          };
          this.$http.post(this.$api.shiroApi.sendCaptchaByPhone, params).then(({ data }) => {
            if (data.code === 200) {
              this.countdown(60);
            }
          });
        }
      });
    },
    // 倒计时
    countdown(second) {
      const TIME_COUNT = second;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCaptcha = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCaptcha = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    captchaLogin() {
      this.captchaForm = !this.captchaForm;
      this.rules.password[0].required = !this.captchaForm;
      this.rules.captcha[0].required = !this.captchaForm;
      this.rules.captcha_phone[0].required = this.captchaForm;
      this.$refs["loginForm"].resetFields();
    },
    captchaLoginSubmit() {
      let params = {
        phone: this.loginForm.tel,
        code: this.loginForm.captcha_phone,
      };
      this.$http.post(this.$api.shiroApi.captchaLogin, params).then(({ data }) => {
        this.$cookie.set("X-Admin-Token", data.data.token);
        this.$cookie.set("name", data.data.userInfo.name);
        this.$cookie.set("userid", data.data.userInfo.id);
        this.$cookie.set("isAdmin", data.data.userInfo.isAdmin);
        this.$cookie.set("avatar", data.data.userInfo.avatar || '');
        this.$cookie.set("isOtherUser", data.data.userInfo.isOtherUser);
        this.$router.replace({ name: "home" });
      });
    },
    getBanner() {
      this.$http.get(this.$api.bannerApi.getBanner, { params: { type: 'BANNER_DL' } }).then(({
        data
      }) => {
        this.rotationChart = data.data || [];
      });
    },
    // 立即登录
    submitForm() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          if (this.captchaForm) {//手机验证码登录
            this.captchaLoginSubmit();
            return
          }
          let params = {
            phone: this.loginForm.tel,
            password: RSAEncrypt(this.loginForm.password),
            captcha: this.loginForm.captcha,
          };
          this.$http.post(this.$api.shiroApi.login, params).then(({ data }) => {
            this.$cookie.set("X-Admin-Token", data.data.token);
            this.$cookie.set("name", data.data.userInfo.name);
            this.$cookie.set("userid", data.data.userInfo.id);
            this.$cookie.set("isAdmin", data.data.userInfo.isAdmin);
            this.$cookie.set("avatar", data.data.userInfo.avatar || '');
            this.$cookie.set("isOtherUser", data.data.userInfo.isOtherUser);
            this.$router.replace({ name: "home" });
          }).catch(() => {
            this.getCaptcha();
          });
        }
      });
    },
    // 获取验证码
    getCaptcha() {
      this.$http.get(this.$api.shiroApi.captcha).then(({ data }) => {
        this.captchaPath = "data:image/png;base64," + data.data;
      });
    },
    // 显示密码
    showPwdHandle() {
      this.pwdShow = !this.pwdShow;
    },
    // 轮播图跳转
    goUrl(item) {
      if (!item.url) return
      location.href = item.url;
    }
  },
};
</script>

<style lang="scss" scoped>
.captchaLoginTitle {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  display: inline-block;
}

.captchaLoginTitle1 {
  width: 16px;
  height: 0px;
  border: 2px solid #1460AE;
  margin: 0 auto;
  margin-top: 11px;
}

.captchaForm {
  position: relative;
  margin-bottom: 53px;
  input {
    padding-right: 106px;
  }
}

.getcaptcha {
  position: absolute;
  color: #1460AE;
  font-weight: bold;
  cursor: pointer;
  top: 18px;
  right: 20px;
}

.hold {
  text-align: center;
  color: #8C8C8C;
  background: url('~@/assets/img/logo_.png') no-repeat 66%;
}

.mod-login {
  ::v-deep .el-carousel {
    height: 100%;

    ul.el-carousel__indicators--horizontal {
      bottom: 92px;
      width: 1200px;
    }
  }

  .login-panel {
    width: 424px;
    height: 547px;
    margin: 0 auto;
    padding: 20px 40px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
    box-sizing: border-box;
    border-radius: 32px;

    .login-title {
      margin-bottom: 35px;

      h3 {
        font-size: 21px;
        line-height: 38px;
      }
    }

    .login-form {
      padding: 0 30px;

      .captcha_icon {
        height: 18px;
        width: 18px;
        display: inline-block;
        vertical-align: middle;
        background: url("~@/assets/img/yzm.png") no-repeat center;
      }

      .captcha_img {
        width: 100%;
        height: 50px;
        background: #d9d9d98c;
      }

      .resetpwd {
        color: #1460ae;
        text-align: right;
        margin-bottom: 30px;
        cursor: pointer;
      }

      .eye {
        display: inline-block;
        width: 24px;
        height: 100%;
        background: url("~@/assets/img/ceye.png") no-repeat center;
        cursor: pointer;
      }

      .ceye {
        background: url("~@/assets/img/ceye.png") no-repeat center !important;
      }

      .oeye {
        background: url("~@/assets/img/oeye.png") no-repeat center !important;
      }

      .phoneIcon {
        display: inline-block;
        width: 24px;
        height: 96%;
        background: url("~@/assets/img/phone.png") no-repeat center;
      }

      .pwdIcon {
        display: inline-block;
        width: 24px;
        height: 96%;
        background: url("~@/assets/img/pwd.png") no-repeat center;
      }
    }
  }
}</style>
